import {ClientFunction, ProxyApiHeader} from '@yandex-taxi/js-integration-api'

import {__CONFIG_NAME__} from './config/consts'

export class HTTPError extends Error {
  data: unknown & {message?: string}
  status: string | number

  constructor(message: string, status: string | number, data: unknown & {message?: string}) {
    super(message)
    this.data = data
    this.status = status

    if (data?.message) {
      this.message = data.message
    }
  }
}

export const client: ClientFunction = options => {
  const {url, body, method, headers, onSuccess, onError} = options
  const controller = new AbortController()
  const lang = window[__CONFIG_NAME__].lang
  const init: RequestInit = {
    credentials: 'include',
    signal: controller.signal,
    body: JSON.stringify(body),
    headers: {...headers, 'Accept-Language': lang},
    method,
  }

  fetch(url, init)
    .then(response => Promise.all([response, response.json()]))
    .then(([response, data]) => {
      if (!response.ok) {
        throw new HTTPError(response.statusText, response.status, data)
      }

      const headers = response.headers.has(ProxyApiHeader.USER_ID)
        ? {[ProxyApiHeader.USER_ID]: response.headers.get(ProxyApiHeader.USER_ID)}
        : undefined

      return [data, headers]
    })
    .then(([data, headers]) => {
      onSuccess?.(data, headers)
    })
    .catch((error: Error) => {
      // ошибку отменного запроса показывать не нужно
      if (onError && error.name !== 'AbortError') {
        onError(error)
      }
    })

  return () => {
    controller.abort()
  }
}
